import React from "react";
import { Grid } from "../../UI/Grid";
import { ModalProvider } from "../../contexts/ModalContext";
import { CommunityInfo } from "../CommunityInfo";
import { BlockedWords } from "../BlockedWords";



export const Community = () => (
  <>
    <Grid container spacing={10}>
      <Grid item xs={12}>
        <CommunityInfo />
      </Grid>
      <Grid item xs={12}>
        <ModalProvider>
          <BlockedWords />
        </ModalProvider>
      </Grid>
    </Grid>
  </>
);
